import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showArrow)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "scroll-to-top",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args)))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("span", { class: "arrow-icon" }, "↑", -1)
      ])))
    : _createCommentVNode("", true)
}